
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireff0f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireff0f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hKdZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb1972acc1ecda9$export$2e2bcd8739ae039);
// packages/alpinejs/src/scheduler.js
var $ceb1972acc1ecda9$var$flushPending = false;
var $ceb1972acc1ecda9$var$flushing = false;
var $ceb1972acc1ecda9$var$queue = [];
var $ceb1972acc1ecda9$var$lastFlushedIndex = -1;
function $ceb1972acc1ecda9$var$scheduler(callback) {
    $ceb1972acc1ecda9$var$queueJob(callback);
}
function $ceb1972acc1ecda9$var$queueJob(job) {
    if (!$ceb1972acc1ecda9$var$queue.includes(job)) $ceb1972acc1ecda9$var$queue.push(job);
    $ceb1972acc1ecda9$var$queueFlush();
}
function $ceb1972acc1ecda9$var$dequeueJob(job) {
    let index = $ceb1972acc1ecda9$var$queue.indexOf(job);
    if (index !== -1 && index > $ceb1972acc1ecda9$var$lastFlushedIndex) $ceb1972acc1ecda9$var$queue.splice(index, 1);
}
function $ceb1972acc1ecda9$var$queueFlush() {
    if (!$ceb1972acc1ecda9$var$flushing && !$ceb1972acc1ecda9$var$flushPending) {
        $ceb1972acc1ecda9$var$flushPending = true;
        queueMicrotask($ceb1972acc1ecda9$var$flushJobs);
    }
}
function $ceb1972acc1ecda9$var$flushJobs() {
    $ceb1972acc1ecda9$var$flushPending = false;
    $ceb1972acc1ecda9$var$flushing = true;
    for(let i = 0; i < $ceb1972acc1ecda9$var$queue.length; i++){
        $ceb1972acc1ecda9$var$queue[i]();
        $ceb1972acc1ecda9$var$lastFlushedIndex = i;
    }
    $ceb1972acc1ecda9$var$queue.length = 0;
    $ceb1972acc1ecda9$var$lastFlushedIndex = -1;
    $ceb1972acc1ecda9$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $ceb1972acc1ecda9$var$reactive;
var $ceb1972acc1ecda9$var$effect;
var $ceb1972acc1ecda9$var$release;
var $ceb1972acc1ecda9$var$raw;
var $ceb1972acc1ecda9$var$shouldSchedule = true;
function $ceb1972acc1ecda9$var$disableEffectScheduling(callback) {
    $ceb1972acc1ecda9$var$shouldSchedule = false;
    callback();
    $ceb1972acc1ecda9$var$shouldSchedule = true;
}
function $ceb1972acc1ecda9$var$setReactivityEngine(engine) {
    $ceb1972acc1ecda9$var$reactive = engine.reactive;
    $ceb1972acc1ecda9$var$release = engine.release;
    $ceb1972acc1ecda9$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($ceb1972acc1ecda9$var$shouldSchedule) $ceb1972acc1ecda9$var$scheduler(task);
                else task();
            }
        });
    $ceb1972acc1ecda9$var$raw = engine.raw;
}
function $ceb1972acc1ecda9$var$overrideEffect(override) {
    $ceb1972acc1ecda9$var$effect = override;
}
function $ceb1972acc1ecda9$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $ceb1972acc1ecda9$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $ceb1972acc1ecda9$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $ceb1972acc1ecda9$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $ceb1972acc1ecda9$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$ceb1972acc1ecda9$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $ceb1972acc1ecda9$var$onAttributeAddeds = [];
var $ceb1972acc1ecda9$var$onElRemoveds = [];
var $ceb1972acc1ecda9$var$onElAddeds = [];
function $ceb1972acc1ecda9$var$onElAdded(callback) {
    $ceb1972acc1ecda9$var$onElAddeds.push(callback);
}
function $ceb1972acc1ecda9$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $ceb1972acc1ecda9$var$onElRemoveds.push(callback);
    }
}
function $ceb1972acc1ecda9$var$onAttributesAdded(callback) {
    $ceb1972acc1ecda9$var$onAttributeAddeds.push(callback);
}
function $ceb1972acc1ecda9$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $ceb1972acc1ecda9$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $ceb1972acc1ecda9$var$cleanupElement(el) {
    el._x_effects?.forEach($ceb1972acc1ecda9$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $ceb1972acc1ecda9$var$observer = new MutationObserver($ceb1972acc1ecda9$var$onMutate);
var $ceb1972acc1ecda9$var$currentlyObserving = false;
function $ceb1972acc1ecda9$var$startObservingMutations() {
    $ceb1972acc1ecda9$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $ceb1972acc1ecda9$var$currentlyObserving = true;
}
function $ceb1972acc1ecda9$var$stopObservingMutations() {
    $ceb1972acc1ecda9$var$flushObserver();
    $ceb1972acc1ecda9$var$observer.disconnect();
    $ceb1972acc1ecda9$var$currentlyObserving = false;
}
var $ceb1972acc1ecda9$var$queuedMutations = [];
function $ceb1972acc1ecda9$var$flushObserver() {
    let records = $ceb1972acc1ecda9$var$observer.takeRecords();
    $ceb1972acc1ecda9$var$queuedMutations.push(()=>records.length > 0 && $ceb1972acc1ecda9$var$onMutate(records));
    let queueLengthWhenTriggered = $ceb1972acc1ecda9$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($ceb1972acc1ecda9$var$queuedMutations.length === queueLengthWhenTriggered) while($ceb1972acc1ecda9$var$queuedMutations.length > 0)$ceb1972acc1ecda9$var$queuedMutations.shift()();
    });
}
function $ceb1972acc1ecda9$var$mutateDom(callback) {
    if (!$ceb1972acc1ecda9$var$currentlyObserving) return callback();
    $ceb1972acc1ecda9$var$stopObservingMutations();
    let result = callback();
    $ceb1972acc1ecda9$var$startObservingMutations();
    return result;
}
var $ceb1972acc1ecda9$var$isCollecting = false;
var $ceb1972acc1ecda9$var$deferredMutations = [];
function $ceb1972acc1ecda9$var$deferMutations() {
    $ceb1972acc1ecda9$var$isCollecting = true;
}
function $ceb1972acc1ecda9$var$flushAndStopDeferringMutations() {
    $ceb1972acc1ecda9$var$isCollecting = false;
    $ceb1972acc1ecda9$var$onMutate($ceb1972acc1ecda9$var$deferredMutations);
    $ceb1972acc1ecda9$var$deferredMutations = [];
}
function $ceb1972acc1ecda9$var$onMutate(mutations) {
    if ($ceb1972acc1ecda9$var$isCollecting) {
        $ceb1972acc1ecda9$var$deferredMutations = $ceb1972acc1ecda9$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $ceb1972acc1ecda9$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $ceb1972acc1ecda9$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $ceb1972acc1ecda9$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $ceb1972acc1ecda9$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $ceb1972acc1ecda9$var$scope(node) {
    return $ceb1972acc1ecda9$var$mergeProxies($ceb1972acc1ecda9$var$closestDataStack(node));
}
function $ceb1972acc1ecda9$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$ceb1972acc1ecda9$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $ceb1972acc1ecda9$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $ceb1972acc1ecda9$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $ceb1972acc1ecda9$var$closestDataStack(node.parentNode);
}
function $ceb1972acc1ecda9$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $ceb1972acc1ecda9$var$mergeProxyTrap);
}
var $ceb1972acc1ecda9$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $ceb1972acc1ecda9$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $ceb1972acc1ecda9$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $ceb1972acc1ecda9$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $ceb1972acc1ecda9$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$ceb1972acc1ecda9$var$get(data2, path), (value)=>$ceb1972acc1ecda9$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $ceb1972acc1ecda9$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $ceb1972acc1ecda9$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $ceb1972acc1ecda9$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $ceb1972acc1ecda9$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $ceb1972acc1ecda9$var$magics = {};
function $ceb1972acc1ecda9$var$magic(name, callback) {
    $ceb1972acc1ecda9$var$magics[name] = callback;
}
function $ceb1972acc1ecda9$var$injectMagics(obj, el) {
    let memoizedUtilities = $ceb1972acc1ecda9$var$getUtilities(el);
    Object.entries($ceb1972acc1ecda9$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $ceb1972acc1ecda9$var$getUtilities(el) {
    let [utilities, cleanup2] = $ceb1972acc1ecda9$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $ceb1972acc1ecda9$var$interceptor,
        ...utilities
    };
    $ceb1972acc1ecda9$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $ceb1972acc1ecda9$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $ceb1972acc1ecda9$var$handleError(e, el, expression);
    }
}
function $ceb1972acc1ecda9$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = true;
function $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions(callback) {
    let cache = $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions;
    $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $ceb1972acc1ecda9$var$evaluate(el, expression, extras = {}) {
    let result;
    $ceb1972acc1ecda9$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $ceb1972acc1ecda9$var$evaluateLater(...args) {
    return $ceb1972acc1ecda9$var$theEvaluatorFunction(...args);
}
var $ceb1972acc1ecda9$var$theEvaluatorFunction = $ceb1972acc1ecda9$var$normalEvaluator;
function $ceb1972acc1ecda9$var$setEvaluator(newEvaluator) {
    $ceb1972acc1ecda9$var$theEvaluatorFunction = newEvaluator;
}
function $ceb1972acc1ecda9$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $ceb1972acc1ecda9$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$ceb1972acc1ecda9$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $ceb1972acc1ecda9$var$generateEvaluatorFromFunction(dataStack, expression) : $ceb1972acc1ecda9$var$generateEvaluatorFromString(dataStack, expression, el);
    return $ceb1972acc1ecda9$var$tryCatch.bind(null, el, expression, evaluator);
}
function $ceb1972acc1ecda9$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($ceb1972acc1ecda9$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, result);
    };
}
var $ceb1972acc1ecda9$var$evaluatorMemo = {};
function $ceb1972acc1ecda9$var$generateFunctionFromString(expression, el) {
    if ($ceb1972acc1ecda9$var$evaluatorMemo[expression]) return $ceb1972acc1ecda9$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $ceb1972acc1ecda9$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $ceb1972acc1ecda9$var$evaluatorMemo[expression] = func;
    return func;
}
function $ceb1972acc1ecda9$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $ceb1972acc1ecda9$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $ceb1972acc1ecda9$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, expression));
            if (func.finished) {
                $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($ceb1972acc1ecda9$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$ceb1972acc1ecda9$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$ceb1972acc1ecda9$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $ceb1972acc1ecda9$var$prefixAsString = "x-";
function $ceb1972acc1ecda9$var$prefix(subject = "") {
    return $ceb1972acc1ecda9$var$prefixAsString + subject;
}
function $ceb1972acc1ecda9$var$setPrefix(newPrefix) {
    $ceb1972acc1ecda9$var$prefixAsString = newPrefix;
}
var $ceb1972acc1ecda9$var$directiveHandlers = {};
function $ceb1972acc1ecda9$var$directive(name, callback) {
    $ceb1972acc1ecda9$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$ceb1972acc1ecda9$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $ceb1972acc1ecda9$var$directiveOrder.indexOf(directive2);
            $ceb1972acc1ecda9$var$directiveOrder.splice(pos >= 0 ? pos : $ceb1972acc1ecda9$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $ceb1972acc1ecda9$var$directiveExists(name) {
    return Object.keys($ceb1972acc1ecda9$var$directiveHandlers).includes(name);
}
function $ceb1972acc1ecda9$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $ceb1972acc1ecda9$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($ceb1972acc1ecda9$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($ceb1972acc1ecda9$var$outNonAlpineAttributes).map($ceb1972acc1ecda9$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($ceb1972acc1ecda9$var$byPriority);
    return directives2.map((directive2)=>{
        return $ceb1972acc1ecda9$var$getDirectiveHandler(el, directive2);
    });
}
function $ceb1972acc1ecda9$var$attributesOnly(attributes) {
    return Array.from(attributes).map($ceb1972acc1ecda9$var$toTransformedAttributes()).filter((attr)=>!$ceb1972acc1ecda9$var$outNonAlpineAttributes(attr));
}
var $ceb1972acc1ecda9$var$isDeferringHandlers = false;
var $ceb1972acc1ecda9$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $ceb1972acc1ecda9$var$currentHandlerStackKey = Symbol();
function $ceb1972acc1ecda9$var$deferHandlingDirectives(callback) {
    $ceb1972acc1ecda9$var$isDeferringHandlers = true;
    let key = Symbol();
    $ceb1972acc1ecda9$var$currentHandlerStackKey = key;
    $ceb1972acc1ecda9$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($ceb1972acc1ecda9$var$directiveHandlerStacks.get(key).length)$ceb1972acc1ecda9$var$directiveHandlerStacks.get(key).shift()();
        $ceb1972acc1ecda9$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $ceb1972acc1ecda9$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $ceb1972acc1ecda9$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $ceb1972acc1ecda9$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $ceb1972acc1ecda9$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $ceb1972acc1ecda9$var$evaluateLater.bind($ceb1972acc1ecda9$var$evaluateLater, el),
        evaluate: $ceb1972acc1ecda9$var$evaluate.bind($ceb1972acc1ecda9$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $ceb1972acc1ecda9$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $ceb1972acc1ecda9$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $ceb1972acc1ecda9$var$getElementBoundUtilities(el);
    $ceb1972acc1ecda9$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $ceb1972acc1ecda9$var$isDeferringHandlers ? $ceb1972acc1ecda9$var$directiveHandlerStacks.get($ceb1972acc1ecda9$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $ceb1972acc1ecda9$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $ceb1972acc1ecda9$var$into = (i)=>i;
function $ceb1972acc1ecda9$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $ceb1972acc1ecda9$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $ceb1972acc1ecda9$var$attributeTransformers = [];
function $ceb1972acc1ecda9$var$mapAttributes(callback) {
    $ceb1972acc1ecda9$var$attributeTransformers.push(callback);
}
function $ceb1972acc1ecda9$var$outNonAlpineAttributes({ name: name }) {
    return $ceb1972acc1ecda9$var$alpineAttributeRegex().test(name);
}
var $ceb1972acc1ecda9$var$alpineAttributeRegex = ()=>new RegExp(`^${$ceb1972acc1ecda9$var$prefixAsString}([^:^.]+)\\b`);
function $ceb1972acc1ecda9$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($ceb1972acc1ecda9$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $ceb1972acc1ecda9$var$DEFAULT = "DEFAULT";
var $ceb1972acc1ecda9$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $ceb1972acc1ecda9$var$DEFAULT,
    "teleport"
];
function $ceb1972acc1ecda9$var$byPriority(a, b) {
    let typeA = $ceb1972acc1ecda9$var$directiveOrder.indexOf(a.type) === -1 ? $ceb1972acc1ecda9$var$DEFAULT : a.type;
    let typeB = $ceb1972acc1ecda9$var$directiveOrder.indexOf(b.type) === -1 ? $ceb1972acc1ecda9$var$DEFAULT : b.type;
    return $ceb1972acc1ecda9$var$directiveOrder.indexOf(typeA) - $ceb1972acc1ecda9$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $ceb1972acc1ecda9$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $ceb1972acc1ecda9$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$ceb1972acc1ecda9$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $ceb1972acc1ecda9$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $ceb1972acc1ecda9$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $ceb1972acc1ecda9$var$started = false;
function $ceb1972acc1ecda9$var$start() {
    if ($ceb1972acc1ecda9$var$started) $ceb1972acc1ecda9$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $ceb1972acc1ecda9$var$started = true;
    if (!document.body) $ceb1972acc1ecda9$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:init");
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:initializing");
    $ceb1972acc1ecda9$var$startObservingMutations();
    $ceb1972acc1ecda9$var$onElAdded((el)=>$ceb1972acc1ecda9$var$initTree(el, $ceb1972acc1ecda9$var$walk));
    $ceb1972acc1ecda9$var$onElRemoved((el)=>$ceb1972acc1ecda9$var$destroyTree(el));
    $ceb1972acc1ecda9$var$onAttributesAdded((el, attrs)=>{
        $ceb1972acc1ecda9$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$ceb1972acc1ecda9$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($ceb1972acc1ecda9$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $ceb1972acc1ecda9$var$initTree(el);
    });
    $ceb1972acc1ecda9$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $ceb1972acc1ecda9$var$warnAboutMissingPlugins();
    });
}
var $ceb1972acc1ecda9$var$rootSelectorCallbacks = [];
var $ceb1972acc1ecda9$var$initSelectorCallbacks = [];
function $ceb1972acc1ecda9$var$rootSelectors() {
    return $ceb1972acc1ecda9$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $ceb1972acc1ecda9$var$allSelectors() {
    return $ceb1972acc1ecda9$var$rootSelectorCallbacks.concat($ceb1972acc1ecda9$var$initSelectorCallbacks).map((fn)=>fn());
}
function $ceb1972acc1ecda9$var$addRootSelector(selectorCallback) {
    $ceb1972acc1ecda9$var$rootSelectorCallbacks.push(selectorCallback);
}
function $ceb1972acc1ecda9$var$addInitSelector(selectorCallback) {
    $ceb1972acc1ecda9$var$initSelectorCallbacks.push(selectorCallback);
}
function $ceb1972acc1ecda9$var$closestRoot(el, includeInitSelectors = false) {
    return $ceb1972acc1ecda9$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $ceb1972acc1ecda9$var$allSelectors() : $ceb1972acc1ecda9$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $ceb1972acc1ecda9$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $ceb1972acc1ecda9$var$findClosest(el.parentElement, callback);
}
function $ceb1972acc1ecda9$var$isRoot(el) {
    return $ceb1972acc1ecda9$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $ceb1972acc1ecda9$var$initInterceptors2 = [];
function $ceb1972acc1ecda9$var$interceptInit(callback) {
    $ceb1972acc1ecda9$var$initInterceptors2.push(callback);
}
var $ceb1972acc1ecda9$var$markerDispenser = 1;
function $ceb1972acc1ecda9$var$initTree(el, walker = $ceb1972acc1ecda9$var$walk, intercept = ()=>{}) {
    if ($ceb1972acc1ecda9$var$findClosest(el, (i)=>i._x_ignore)) return;
    $ceb1972acc1ecda9$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $ceb1972acc1ecda9$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $ceb1972acc1ecda9$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $ceb1972acc1ecda9$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $ceb1972acc1ecda9$var$destroyTree(root, walker = $ceb1972acc1ecda9$var$walk) {
    walker(root, (el)=>{
        $ceb1972acc1ecda9$var$cleanupElement(el);
        $ceb1972acc1ecda9$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $ceb1972acc1ecda9$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($ceb1972acc1ecda9$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $ceb1972acc1ecda9$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $ceb1972acc1ecda9$var$tickStack = [];
var $ceb1972acc1ecda9$var$isHolding = false;
function $ceb1972acc1ecda9$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $ceb1972acc1ecda9$var$isHolding || setTimeout(()=>{
            $ceb1972acc1ecda9$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $ceb1972acc1ecda9$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $ceb1972acc1ecda9$var$releaseNextTicks() {
    $ceb1972acc1ecda9$var$isHolding = false;
    while($ceb1972acc1ecda9$var$tickStack.length)$ceb1972acc1ecda9$var$tickStack.shift()();
}
function $ceb1972acc1ecda9$var$holdNextTicks() {
    $ceb1972acc1ecda9$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $ceb1972acc1ecda9$var$setClasses(el, value) {
    if (Array.isArray(value)) return $ceb1972acc1ecda9$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $ceb1972acc1ecda9$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $ceb1972acc1ecda9$var$setClasses(el, value());
    return $ceb1972acc1ecda9$var$setClassesFromString(el, value);
}
function $ceb1972acc1ecda9$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $ceb1972acc1ecda9$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $ceb1972acc1ecda9$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $ceb1972acc1ecda9$var$setStylesFromObject(el, value);
    return $ceb1972acc1ecda9$var$setStylesFromString(el, value);
}
function $ceb1972acc1ecda9$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $ceb1972acc1ecda9$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $ceb1972acc1ecda9$var$setStyles(el, previousStyles);
    };
}
function $ceb1972acc1ecda9$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $ceb1972acc1ecda9$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $ceb1972acc1ecda9$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$ceb1972acc1ecda9$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $ceb1972acc1ecda9$var$registerTransitionsFromHelper(el, modifiers, value);
    else $ceb1972acc1ecda9$var$registerTransitionsFromClassString(el, expression, value);
});
function $ceb1972acc1ecda9$var$registerTransitionsFromClassString(el, classString, stage) {
    $ceb1972acc1ecda9$var$registerTransitionObject(el, $ceb1972acc1ecda9$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $ceb1972acc1ecda9$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $ceb1972acc1ecda9$var$registerTransitionObject(el, $ceb1972acc1ecda9$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $ceb1972acc1ecda9$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $ceb1972acc1ecda9$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $ceb1972acc1ecda9$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $ceb1972acc1ecda9$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $ceb1972acc1ecda9$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $ceb1972acc1ecda9$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $ceb1972acc1ecda9$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $ceb1972acc1ecda9$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $ceb1972acc1ecda9$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $ceb1972acc1ecda9$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $ceb1972acc1ecda9$var$closestHide(parent);
}
function $ceb1972acc1ecda9$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $ceb1972acc1ecda9$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $ceb1972acc1ecda9$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $ceb1972acc1ecda9$var$once(()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $ceb1972acc1ecda9$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $ceb1972acc1ecda9$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $ceb1972acc1ecda9$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $ceb1972acc1ecda9$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                stages.end();
            });
            $ceb1972acc1ecda9$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $ceb1972acc1ecda9$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $ceb1972acc1ecda9$var$isCloning = false;
function $ceb1972acc1ecda9$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$ceb1972acc1ecda9$var$isCloning ? fallback(...args) : callback(...args);
}
function $ceb1972acc1ecda9$var$onlyDuringClone(callback) {
    return (...args)=>$ceb1972acc1ecda9$var$isCloning && callback(...args);
}
var $ceb1972acc1ecda9$var$interceptors = [];
function $ceb1972acc1ecda9$var$interceptClone(callback) {
    $ceb1972acc1ecda9$var$interceptors.push(callback);
}
function $ceb1972acc1ecda9$var$cloneNode(from, to) {
    $ceb1972acc1ecda9$var$interceptors.forEach((i)=>i(from, to));
    $ceb1972acc1ecda9$var$isCloning = true;
    $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(()=>{
        $ceb1972acc1ecda9$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $ceb1972acc1ecda9$var$isCloning = false;
}
var $ceb1972acc1ecda9$var$isCloningLegacy = false;
function $ceb1972acc1ecda9$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $ceb1972acc1ecda9$var$isCloning = true;
    $ceb1972acc1ecda9$var$isCloningLegacy = true;
    $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(()=>{
        $ceb1972acc1ecda9$var$cloneTree(newEl);
    });
    $ceb1972acc1ecda9$var$isCloning = false;
    $ceb1972acc1ecda9$var$isCloningLegacy = false;
}
function $ceb1972acc1ecda9$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $ceb1972acc1ecda9$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $ceb1972acc1ecda9$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $ceb1972acc1ecda9$var$initTree(el, shallowWalker);
}
function $ceb1972acc1ecda9$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $ceb1972acc1ecda9$var$effect;
    $ceb1972acc1ecda9$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $ceb1972acc1ecda9$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $ceb1972acc1ecda9$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $ceb1972acc1ecda9$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $ceb1972acc1ecda9$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $ceb1972acc1ecda9$var$camelCase(name) : name;
    switch(name){
        case "value":
            $ceb1972acc1ecda9$var$bindInputValue(el, value);
            break;
        case "style":
            $ceb1972acc1ecda9$var$bindStyles(el, value);
            break;
        case "class":
            $ceb1972acc1ecda9$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $ceb1972acc1ecda9$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $ceb1972acc1ecda9$var$bindAttribute(el, name, value);
            break;
    }
}
function $ceb1972acc1ecda9$var$bindInputValue(el, value) {
    if ($ceb1972acc1ecda9$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $ceb1972acc1ecda9$var$safeParseBoolean(el.value) === value;
            else el.checked = $ceb1972acc1ecda9$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($ceb1972acc1ecda9$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$ceb1972acc1ecda9$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $ceb1972acc1ecda9$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $ceb1972acc1ecda9$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $ceb1972acc1ecda9$var$setClasses(el, value);
}
function $ceb1972acc1ecda9$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $ceb1972acc1ecda9$var$setStyles(el, value);
}
function $ceb1972acc1ecda9$var$bindAttributeAndProperty(el, name, value) {
    $ceb1972acc1ecda9$var$bindAttribute(el, name, value);
    $ceb1972acc1ecda9$var$setPropertyIfChanged(el, name, value);
}
function $ceb1972acc1ecda9$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $ceb1972acc1ecda9$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($ceb1972acc1ecda9$var$isBooleanAttr(name)) value = name;
        $ceb1972acc1ecda9$var$setIfChanged(el, name, value);
    }
}
function $ceb1972acc1ecda9$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $ceb1972acc1ecda9$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $ceb1972acc1ecda9$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $ceb1972acc1ecda9$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $ceb1972acc1ecda9$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $ceb1972acc1ecda9$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $ceb1972acc1ecda9$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $ceb1972acc1ecda9$var$isBooleanAttr(attrName) {
    return $ceb1972acc1ecda9$var$booleanAttributes.has(attrName);
}
function $ceb1972acc1ecda9$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $ceb1972acc1ecda9$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback);
}
function $ceb1972acc1ecda9$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions(()=>{
            return $ceb1972acc1ecda9$var$evaluate(el, binding.expression);
        });
    }
    return $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback);
}
function $ceb1972acc1ecda9$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($ceb1972acc1ecda9$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $ceb1972acc1ecda9$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $ceb1972acc1ecda9$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $ceb1972acc1ecda9$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $ceb1972acc1ecda9$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $ceb1972acc1ecda9$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $ceb1972acc1ecda9$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($ceb1972acc1ecda9$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($ceb1972acc1ecda9$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($ceb1972acc1ecda9$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $ceb1972acc1ecda9$var$release(reference);
    };
}
function $ceb1972acc1ecda9$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $ceb1972acc1ecda9$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($ceb1972acc1ecda9$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $ceb1972acc1ecda9$var$stores = {};
var $ceb1972acc1ecda9$var$isReactive = false;
function $ceb1972acc1ecda9$var$store(name, value) {
    if (!$ceb1972acc1ecda9$var$isReactive) {
        $ceb1972acc1ecda9$var$stores = $ceb1972acc1ecda9$var$reactive($ceb1972acc1ecda9$var$stores);
        $ceb1972acc1ecda9$var$isReactive = true;
    }
    if (value === void 0) return $ceb1972acc1ecda9$var$stores[name];
    $ceb1972acc1ecda9$var$stores[name] = value;
    $ceb1972acc1ecda9$var$initInterceptors($ceb1972acc1ecda9$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $ceb1972acc1ecda9$var$stores[name].init();
}
function $ceb1972acc1ecda9$var$getStores() {
    return $ceb1972acc1ecda9$var$stores;
}
// packages/alpinejs/src/binds.js
var $ceb1972acc1ecda9$var$binds = {};
function $ceb1972acc1ecda9$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $ceb1972acc1ecda9$var$applyBindingsObject(name, getBindings());
    else $ceb1972acc1ecda9$var$binds[name] = getBindings;
    return ()=>{};
}
function $ceb1972acc1ecda9$var$injectBindingProviders(obj) {
    Object.entries($ceb1972acc1ecda9$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $ceb1972acc1ecda9$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $ceb1972acc1ecda9$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $ceb1972acc1ecda9$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $ceb1972acc1ecda9$var$datas = {};
function $ceb1972acc1ecda9$var$data(name, callback) {
    $ceb1972acc1ecda9$var$datas[name] = callback;
}
function $ceb1972acc1ecda9$var$injectDataProviders(obj, context) {
    Object.entries($ceb1972acc1ecda9$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $ceb1972acc1ecda9$var$Alpine = {
    get reactive () {
        return $ceb1972acc1ecda9$var$reactive;
    },
    get release () {
        return $ceb1972acc1ecda9$var$release;
    },
    get effect () {
        return $ceb1972acc1ecda9$var$effect;
    },
    get raw () {
        return $ceb1972acc1ecda9$var$raw;
    },
    version: "3.14.9",
    flushAndStopDeferringMutations: $ceb1972acc1ecda9$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $ceb1972acc1ecda9$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $ceb1972acc1ecda9$var$disableEffectScheduling,
    startObservingMutations: $ceb1972acc1ecda9$var$startObservingMutations,
    stopObservingMutations: $ceb1972acc1ecda9$var$stopObservingMutations,
    setReactivityEngine: $ceb1972acc1ecda9$var$setReactivityEngine,
    onAttributeRemoved: $ceb1972acc1ecda9$var$onAttributeRemoved,
    onAttributesAdded: $ceb1972acc1ecda9$var$onAttributesAdded,
    closestDataStack: $ceb1972acc1ecda9$var$closestDataStack,
    skipDuringClone: $ceb1972acc1ecda9$var$skipDuringClone,
    onlyDuringClone: $ceb1972acc1ecda9$var$onlyDuringClone,
    addRootSelector: $ceb1972acc1ecda9$var$addRootSelector,
    addInitSelector: $ceb1972acc1ecda9$var$addInitSelector,
    interceptClone: $ceb1972acc1ecda9$var$interceptClone,
    addScopeToNode: $ceb1972acc1ecda9$var$addScopeToNode,
    deferMutations: $ceb1972acc1ecda9$var$deferMutations,
    mapAttributes: $ceb1972acc1ecda9$var$mapAttributes,
    evaluateLater: $ceb1972acc1ecda9$var$evaluateLater,
    interceptInit: $ceb1972acc1ecda9$var$interceptInit,
    setEvaluator: $ceb1972acc1ecda9$var$setEvaluator,
    mergeProxies: $ceb1972acc1ecda9$var$mergeProxies,
    extractProp: $ceb1972acc1ecda9$var$extractProp,
    findClosest: $ceb1972acc1ecda9$var$findClosest,
    onElRemoved: $ceb1972acc1ecda9$var$onElRemoved,
    closestRoot: $ceb1972acc1ecda9$var$closestRoot,
    destroyTree: $ceb1972acc1ecda9$var$destroyTree,
    interceptor: $ceb1972acc1ecda9$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $ceb1972acc1ecda9$var$transition,
    setStyles: // INTERNAL
    $ceb1972acc1ecda9$var$setStyles,
    mutateDom: // INTERNAL
    $ceb1972acc1ecda9$var$mutateDom,
    directive: $ceb1972acc1ecda9$var$directive,
    entangle: $ceb1972acc1ecda9$var$entangle,
    throttle: $ceb1972acc1ecda9$var$throttle,
    debounce: $ceb1972acc1ecda9$var$debounce,
    evaluate: $ceb1972acc1ecda9$var$evaluate,
    initTree: $ceb1972acc1ecda9$var$initTree,
    nextTick: $ceb1972acc1ecda9$var$nextTick,
    prefixed: $ceb1972acc1ecda9$var$prefix,
    prefix: $ceb1972acc1ecda9$var$setPrefix,
    plugin: $ceb1972acc1ecda9$var$plugin,
    magic: $ceb1972acc1ecda9$var$magic,
    store: $ceb1972acc1ecda9$var$store,
    start: $ceb1972acc1ecda9$var$start,
    clone: $ceb1972acc1ecda9$var$clone,
    cloneNode: // INTERNAL
    $ceb1972acc1ecda9$var$cloneNode,
    // INTERNAL
    bound: $ceb1972acc1ecda9$var$getBinding,
    $data: $ceb1972acc1ecda9$var$scope,
    watch: $ceb1972acc1ecda9$var$watch,
    walk: $ceb1972acc1ecda9$var$walk,
    data: $ceb1972acc1ecda9$var$data,
    bind: $ceb1972acc1ecda9$var$bind2
};
var $ceb1972acc1ecda9$var$alpine_default = $ceb1972acc1ecda9$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $ceb1972acc1ecda9$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $ceb1972acc1ecda9$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $ceb1972acc1ecda9$var$isBooleanAttr2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$makeMap($ceb1972acc1ecda9$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $ceb1972acc1ecda9$var$EMPTY_OBJ = Object.freeze({});
var $ceb1972acc1ecda9$var$EMPTY_ARR = Object.freeze([]);
var $ceb1972acc1ecda9$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $ceb1972acc1ecda9$var$hasOwn = (val, key)=>$ceb1972acc1ecda9$var$hasOwnProperty.call(val, key);
var $ceb1972acc1ecda9$var$isArray = Array.isArray;
var $ceb1972acc1ecda9$var$isMap = (val)=>$ceb1972acc1ecda9$var$toTypeString(val) === "[object Map]";
var $ceb1972acc1ecda9$var$isString = (val)=>typeof val === "string";
var $ceb1972acc1ecda9$var$isSymbol = (val)=>typeof val === "symbol";
var $ceb1972acc1ecda9$var$isObject = (val)=>val !== null && typeof val === "object";
var $ceb1972acc1ecda9$var$objectToString = Object.prototype.toString;
var $ceb1972acc1ecda9$var$toTypeString = (value)=>$ceb1972acc1ecda9$var$objectToString.call(value);
var $ceb1972acc1ecda9$var$toRawType = (value)=>{
    return $ceb1972acc1ecda9$var$toTypeString(value).slice(8, -1);
};
var $ceb1972acc1ecda9$var$isIntegerKey = (key)=>$ceb1972acc1ecda9$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $ceb1972acc1ecda9$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $ceb1972acc1ecda9$var$camelizeRE = /-(\w)/g;
var $ceb1972acc1ecda9$var$camelize = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>{
    return str.replace($ceb1972acc1ecda9$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $ceb1972acc1ecda9$var$hyphenateRE = /\B([A-Z])/g;
var $ceb1972acc1ecda9$var$hyphenate = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str.replace($ceb1972acc1ecda9$var$hyphenateRE, "-$1").toLowerCase());
var $ceb1972acc1ecda9$var$capitalize = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $ceb1972acc1ecda9$var$toHandlerKey = $ceb1972acc1ecda9$var$cacheStringFunction((str)=>str ? `on${$ceb1972acc1ecda9$var$capitalize(str)}` : ``);
var $ceb1972acc1ecda9$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $ceb1972acc1ecda9$var$targetMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$effectStack = [];
var $ceb1972acc1ecda9$var$activeEffect;
var $ceb1972acc1ecda9$var$ITERATE_KEY = Symbol("iterate");
var $ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $ceb1972acc1ecda9$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $ceb1972acc1ecda9$var$effect2(fn, options = $ceb1972acc1ecda9$var$EMPTY_OBJ) {
    if ($ceb1972acc1ecda9$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $ceb1972acc1ecda9$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $ceb1972acc1ecda9$var$stop(effect3) {
    if (effect3.active) {
        $ceb1972acc1ecda9$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $ceb1972acc1ecda9$var$uid = 0;
function $ceb1972acc1ecda9$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$ceb1972acc1ecda9$var$effectStack.includes(effect3)) {
            $ceb1972acc1ecda9$var$cleanup(effect3);
            try {
                $ceb1972acc1ecda9$var$enableTracking();
                $ceb1972acc1ecda9$var$effectStack.push(effect3);
                $ceb1972acc1ecda9$var$activeEffect = effect3;
                return fn();
            } finally{
                $ceb1972acc1ecda9$var$effectStack.pop();
                $ceb1972acc1ecda9$var$resetTracking();
                $ceb1972acc1ecda9$var$activeEffect = $ceb1972acc1ecda9$var$effectStack[$ceb1972acc1ecda9$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $ceb1972acc1ecda9$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $ceb1972acc1ecda9$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $ceb1972acc1ecda9$var$shouldTrack = true;
var $ceb1972acc1ecda9$var$trackStack = [];
function $ceb1972acc1ecda9$var$pauseTracking() {
    $ceb1972acc1ecda9$var$trackStack.push($ceb1972acc1ecda9$var$shouldTrack);
    $ceb1972acc1ecda9$var$shouldTrack = false;
}
function $ceb1972acc1ecda9$var$enableTracking() {
    $ceb1972acc1ecda9$var$trackStack.push($ceb1972acc1ecda9$var$shouldTrack);
    $ceb1972acc1ecda9$var$shouldTrack = true;
}
function $ceb1972acc1ecda9$var$resetTracking() {
    const last = $ceb1972acc1ecda9$var$trackStack.pop();
    $ceb1972acc1ecda9$var$shouldTrack = last === void 0 ? true : last;
}
function $ceb1972acc1ecda9$var$track(target, type, key) {
    if (!$ceb1972acc1ecda9$var$shouldTrack || $ceb1972acc1ecda9$var$activeEffect === void 0) return;
    let depsMap = $ceb1972acc1ecda9$var$targetMap.get(target);
    if (!depsMap) $ceb1972acc1ecda9$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($ceb1972acc1ecda9$var$activeEffect)) {
        dep.add($ceb1972acc1ecda9$var$activeEffect);
        $ceb1972acc1ecda9$var$activeEffect.deps.push(dep);
        if ($ceb1972acc1ecda9$var$activeEffect.options.onTrack) $ceb1972acc1ecda9$var$activeEffect.options.onTrack({
            effect: $ceb1972acc1ecda9$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $ceb1972acc1ecda9$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $ceb1972acc1ecda9$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $ceb1972acc1ecda9$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $ceb1972acc1ecda9$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$ceb1972acc1ecda9$var$isArray(target)) {
                    add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                    if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY));
                } else if ($ceb1972acc1ecda9$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$ceb1972acc1ecda9$var$isArray(target)) {
                    add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                    if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($ceb1972acc1ecda9$var$isMap(target)) add2(depsMap.get($ceb1972acc1ecda9$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $ceb1972acc1ecda9$var$isNonTrackableKeys = /* @__PURE__ */ $ceb1972acc1ecda9$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $ceb1972acc1ecda9$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($ceb1972acc1ecda9$var$isSymbol));
var $ceb1972acc1ecda9$var$get2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$createGetter();
var $ceb1972acc1ecda9$var$readonlyGet = /* @__PURE__ */ $ceb1972acc1ecda9$var$createGetter(true);
var $ceb1972acc1ecda9$var$arrayInstrumentations = /* @__PURE__ */ $ceb1972acc1ecda9$var$createArrayInstrumentations();
function $ceb1972acc1ecda9$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $ceb1972acc1ecda9$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$ceb1972acc1ecda9$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($ceb1972acc1ecda9$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $ceb1972acc1ecda9$var$pauseTracking();
            const res = $ceb1972acc1ecda9$var$toRaw(this)[key].apply(this, args);
            $ceb1972acc1ecda9$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $ceb1972acc1ecda9$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $ceb1972acc1ecda9$var$shallowReadonlyMap : $ceb1972acc1ecda9$var$readonlyMap : shallow ? $ceb1972acc1ecda9$var$shallowReactiveMap : $ceb1972acc1ecda9$var$reactiveMap).get(target)) return target;
        const targetIsArray = $ceb1972acc1ecda9$var$isArray(target);
        if (!isReadonly && targetIsArray && $ceb1972acc1ecda9$var$hasOwn($ceb1972acc1ecda9$var$arrayInstrumentations, key)) return Reflect.get($ceb1972acc1ecda9$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($ceb1972acc1ecda9$var$isSymbol(key) ? $ceb1972acc1ecda9$var$builtInSymbols.has(key) : $ceb1972acc1ecda9$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $ceb1972acc1ecda9$var$track(target, "get", key);
        if (shallow) return res;
        if ($ceb1972acc1ecda9$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$ceb1972acc1ecda9$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($ceb1972acc1ecda9$var$isObject(res)) return isReadonly ? $ceb1972acc1ecda9$var$readonly(res) : $ceb1972acc1ecda9$var$reactive2(res);
        return res;
    };
}
var $ceb1972acc1ecda9$var$set2 = /* @__PURE__ */ $ceb1972acc1ecda9$var$createSetter();
function $ceb1972acc1ecda9$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $ceb1972acc1ecda9$var$toRaw(value);
            oldValue = $ceb1972acc1ecda9$var$toRaw(oldValue);
            if (!$ceb1972acc1ecda9$var$isArray(target) && $ceb1972acc1ecda9$var$isRef(oldValue) && !$ceb1972acc1ecda9$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $ceb1972acc1ecda9$var$isArray(target) && $ceb1972acc1ecda9$var$isIntegerKey(key) ? Number(key) < target.length : $ceb1972acc1ecda9$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $ceb1972acc1ecda9$var$toRaw(receiver)) {
            if (!hadKey) $ceb1972acc1ecda9$var$trigger(target, "add", key, value);
            else if ($ceb1972acc1ecda9$var$hasChanged(value, oldValue)) $ceb1972acc1ecda9$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $ceb1972acc1ecda9$var$deleteProperty(target, key) {
    const hadKey = $ceb1972acc1ecda9$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $ceb1972acc1ecda9$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $ceb1972acc1ecda9$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$ceb1972acc1ecda9$var$isSymbol(key) || !$ceb1972acc1ecda9$var$builtInSymbols.has(key)) $ceb1972acc1ecda9$var$track(target, "has", key);
    return result;
}
function $ceb1972acc1ecda9$var$ownKeys(target) {
    $ceb1972acc1ecda9$var$track(target, "iterate", $ceb1972acc1ecda9$var$isArray(target) ? "length" : $ceb1972acc1ecda9$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $ceb1972acc1ecda9$var$mutableHandlers = {
    get: $ceb1972acc1ecda9$var$get2,
    set: $ceb1972acc1ecda9$var$set2,
    deleteProperty: $ceb1972acc1ecda9$var$deleteProperty,
    has: $ceb1972acc1ecda9$var$has,
    ownKeys: $ceb1972acc1ecda9$var$ownKeys
};
var $ceb1972acc1ecda9$var$readonlyHandlers = {
    get: $ceb1972acc1ecda9$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $ceb1972acc1ecda9$var$toReactive = (value)=>$ceb1972acc1ecda9$var$isObject(value) ? $ceb1972acc1ecda9$var$reactive2(value) : value;
var $ceb1972acc1ecda9$var$toReadonly = (value)=>$ceb1972acc1ecda9$var$isObject(value) ? $ceb1972acc1ecda9$var$readonly(value) : value;
var $ceb1972acc1ecda9$var$toShallow = (value)=>value;
var $ceb1972acc1ecda9$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $ceb1972acc1ecda9$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "get", key);
    !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $ceb1972acc1ecda9$var$getProto(rawTarget);
    const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $ceb1972acc1ecda9$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "has", key);
    !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $ceb1972acc1ecda9$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $ceb1972acc1ecda9$var$track($ceb1972acc1ecda9$var$toRaw(target), "iterate", $ceb1972acc1ecda9$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $ceb1972acc1ecda9$var$add(value) {
    value = $ceb1972acc1ecda9$var$toRaw(value);
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const proto = $ceb1972acc1ecda9$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $ceb1972acc1ecda9$var$trigger(target, "add", value, value);
    }
    return this;
}
function $ceb1972acc1ecda9$var$set$1(key, value) {
    value = $ceb1972acc1ecda9$var$toRaw(value);
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const { has: has2, get: get3 } = $ceb1972acc1ecda9$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $ceb1972acc1ecda9$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $ceb1972acc1ecda9$var$trigger(target, "add", key, value);
    else if ($ceb1972acc1ecda9$var$hasChanged(value, oldValue)) $ceb1972acc1ecda9$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $ceb1972acc1ecda9$var$deleteEntry(key) {
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const { has: has2, get: get3 } = $ceb1972acc1ecda9$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $ceb1972acc1ecda9$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $ceb1972acc1ecda9$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $ceb1972acc1ecda9$var$clear() {
    const target = $ceb1972acc1ecda9$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $ceb1972acc1ecda9$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $ceb1972acc1ecda9$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $ceb1972acc1ecda9$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
        const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
        !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "iterate", $ceb1972acc1ecda9$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $ceb1972acc1ecda9$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $ceb1972acc1ecda9$var$toRaw(target);
        const targetIsMap = $ceb1972acc1ecda9$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $ceb1972acc1ecda9$var$toShallow : isReadonly ? $ceb1972acc1ecda9$var$toReadonly : $ceb1972acc1ecda9$var$toReactive;
        !isReadonly && $ceb1972acc1ecda9$var$track(rawTarget, "iterate", isKeyOnly ? $ceb1972acc1ecda9$var$MAP_KEY_ITERATE_KEY : $ceb1972acc1ecda9$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $ceb1972acc1ecda9$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$ceb1972acc1ecda9$var$capitalize(type)} operation ${key}failed: target is readonly.`, $ceb1972acc1ecda9$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $ceb1972acc1ecda9$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this);
        },
        has: $ceb1972acc1ecda9$var$has$1,
        add: $ceb1972acc1ecda9$var$add,
        set: $ceb1972acc1ecda9$var$set$1,
        delete: $ceb1972acc1ecda9$var$deleteEntry,
        clear: $ceb1972acc1ecda9$var$clear,
        forEach: $ceb1972acc1ecda9$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, false, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this);
        },
        has: $ceb1972acc1ecda9$var$has$1,
        add: $ceb1972acc1ecda9$var$add,
        set: $ceb1972acc1ecda9$var$set$1,
        delete: $ceb1972acc1ecda9$var$deleteEntry,
        clear: $ceb1972acc1ecda9$var$clear,
        forEach: $ceb1972acc1ecda9$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this, true);
        },
        has (key) {
            return $ceb1972acc1ecda9$var$has$1.call(this, key, true);
        },
        add: $ceb1972acc1ecda9$var$createReadonlyMethod("add"),
        set: $ceb1972acc1ecda9$var$createReadonlyMethod("set"),
        delete: $ceb1972acc1ecda9$var$createReadonlyMethod("delete"),
        clear: $ceb1972acc1ecda9$var$createReadonlyMethod("clear"),
        forEach: $ceb1972acc1ecda9$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $ceb1972acc1ecda9$var$get$1(this, key, true, true);
        },
        get size () {
            return $ceb1972acc1ecda9$var$size(this, true);
        },
        has (key) {
            return $ceb1972acc1ecda9$var$has$1.call(this, key, true);
        },
        add: $ceb1972acc1ecda9$var$createReadonlyMethod("add"),
        set: $ceb1972acc1ecda9$var$createReadonlyMethod("set"),
        delete: $ceb1972acc1ecda9$var$createReadonlyMethod("delete"),
        clear: $ceb1972acc1ecda9$var$createReadonlyMethod("clear"),
        forEach: $ceb1972acc1ecda9$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $ceb1972acc1ecda9$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$ceb1972acc1ecda9$var$mutableInstrumentations, $ceb1972acc1ecda9$var$readonlyInstrumentations, $ceb1972acc1ecda9$var$shallowInstrumentations, $ceb1972acc1ecda9$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentations();
function $ceb1972acc1ecda9$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $ceb1972acc1ecda9$var$shallowReadonlyInstrumentations : $ceb1972acc1ecda9$var$shallowInstrumentations : isReadonly ? $ceb1972acc1ecda9$var$readonlyInstrumentations : $ceb1972acc1ecda9$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($ceb1972acc1ecda9$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $ceb1972acc1ecda9$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentationGetter(false, false)
};
var $ceb1972acc1ecda9$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $ceb1972acc1ecda9$var$createInstrumentationGetter(true, false)
};
function $ceb1972acc1ecda9$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $ceb1972acc1ecda9$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $ceb1972acc1ecda9$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $ceb1972acc1ecda9$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $ceb1972acc1ecda9$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $ceb1972acc1ecda9$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $ceb1972acc1ecda9$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $ceb1972acc1ecda9$var$targetTypeMap($ceb1972acc1ecda9$var$toRawType(value));
}
function $ceb1972acc1ecda9$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $ceb1972acc1ecda9$var$createReactiveObject(target, false, $ceb1972acc1ecda9$var$mutableHandlers, $ceb1972acc1ecda9$var$mutableCollectionHandlers, $ceb1972acc1ecda9$var$reactiveMap);
}
function $ceb1972acc1ecda9$var$readonly(target) {
    return $ceb1972acc1ecda9$var$createReactiveObject(target, true, $ceb1972acc1ecda9$var$readonlyHandlers, $ceb1972acc1ecda9$var$readonlyCollectionHandlers, $ceb1972acc1ecda9$var$readonlyMap);
}
function $ceb1972acc1ecda9$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$ceb1972acc1ecda9$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $ceb1972acc1ecda9$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $ceb1972acc1ecda9$var$toRaw(observed) {
    return observed && $ceb1972acc1ecda9$var$toRaw(observed["__v_raw"]) || observed;
}
function $ceb1972acc1ecda9$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$ceb1972acc1ecda9$var$magic("nextTick", ()=>$ceb1972acc1ecda9$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$ceb1972acc1ecda9$var$magic("dispatch", (el)=>$ceb1972acc1ecda9$var$dispatch.bind($ceb1972acc1ecda9$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$ceb1972acc1ecda9$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $ceb1972acc1ecda9$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$ceb1972acc1ecda9$var$magic("store", $ceb1972acc1ecda9$var$getStores);
// packages/alpinejs/src/magics/$data.js
$ceb1972acc1ecda9$var$magic("data", (el)=>$ceb1972acc1ecda9$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$ceb1972acc1ecda9$var$magic("root", (el)=>$ceb1972acc1ecda9$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$ceb1972acc1ecda9$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $ceb1972acc1ecda9$var$mergeProxies($ceb1972acc1ecda9$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $ceb1972acc1ecda9$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $ceb1972acc1ecda9$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $ceb1972acc1ecda9$var$globalIdMemo = {};
function $ceb1972acc1ecda9$var$findAndIncrementId(name) {
    if (!$ceb1972acc1ecda9$var$globalIdMemo[name]) $ceb1972acc1ecda9$var$globalIdMemo[name] = 0;
    return ++$ceb1972acc1ecda9$var$globalIdMemo[name];
}
function $ceb1972acc1ecda9$var$closestIdRoot(el, name) {
    return $ceb1972acc1ecda9$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $ceb1972acc1ecda9$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $ceb1972acc1ecda9$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$ceb1972acc1ecda9$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $ceb1972acc1ecda9$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $ceb1972acc1ecda9$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $ceb1972acc1ecda9$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$ceb1972acc1ecda9$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $ceb1972acc1ecda9$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$ceb1972acc1ecda9$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$ceb1972acc1ecda9$var$warnMissingPluginMagic("Focus", "focus", "focus");
$ceb1972acc1ecda9$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $ceb1972acc1ecda9$var$warnMissingPluginMagic(name, magicName, slug) {
    $ceb1972acc1ecda9$var$magic(magicName, (el)=>$ceb1972acc1ecda9$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$ceb1972acc1ecda9$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $ceb1972acc1ecda9$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$ceb1972acc1ecda9$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $ceb1972acc1ecda9$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $ceb1972acc1ecda9$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $ceb1972acc1ecda9$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $ceb1972acc1ecda9$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $ceb1972acc1ecda9$var$skipDuringClone(()=>{
            $ceb1972acc1ecda9$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $ceb1972acc1ecda9$var$getTarget(expression);
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$ceb1972acc1ecda9$var$mutateDom(()=>{
            clone2.remove();
            $ceb1972acc1ecda9$var$destroyTree(clone2);
        }));
});
var $ceb1972acc1ecda9$var$teleportContainerDuringClone = document.createElement("div");
function $ceb1972acc1ecda9$var$getTarget(expression) {
    let target = $ceb1972acc1ecda9$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $ceb1972acc1ecda9$var$teleportContainerDuringClone;
    })();
    if (!target) $ceb1972acc1ecda9$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $ceb1972acc1ecda9$var$handler = ()=>{};
$ceb1972acc1ecda9$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$ceb1972acc1ecda9$var$directive("ignore", $ceb1972acc1ecda9$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$ceb1972acc1ecda9$var$directive("effect", $ceb1972acc1ecda9$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($ceb1972acc1ecda9$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $ceb1972acc1ecda9$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $ceb1972acc1ecda9$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $ceb1972acc1ecda9$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $ceb1972acc1ecda9$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $ceb1972acc1ecda9$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $ceb1972acc1ecda9$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $ceb1972acc1ecda9$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($ceb1972acc1ecda9$var$isKeyEvent(event) || $ceb1972acc1ecda9$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($ceb1972acc1ecda9$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $ceb1972acc1ecda9$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $ceb1972acc1ecda9$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $ceb1972acc1ecda9$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $ceb1972acc1ecda9$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $ceb1972acc1ecda9$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $ceb1972acc1ecda9$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $ceb1972acc1ecda9$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $ceb1972acc1ecda9$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $ceb1972acc1ecda9$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $ceb1972acc1ecda9$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($ceb1972acc1ecda9$var$isClickEvent(e.type)) return false;
            if ($ceb1972acc1ecda9$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $ceb1972acc1ecda9$var$keyToModifiers(key) {
    if (!key) return [];
    key = $ceb1972acc1ecda9$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$ceb1972acc1ecda9$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $ceb1972acc1ecda9$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $ceb1972acc1ecda9$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($ceb1972acc1ecda9$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $ceb1972acc1ecda9$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $ceb1972acc1ecda9$var$isCloning ? ()=>{} : $ceb1972acc1ecda9$var$on(el, event, modifiers, (e)=>{
        setValue($ceb1972acc1ecda9$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $ceb1972acc1ecda9$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($ceb1972acc1ecda9$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $ceb1972acc1ecda9$var$on(el.form, "reset", [], (e)=>{
            $ceb1972acc1ecda9$var$nextTick(()=>el._x_model && el._x_model.set($ceb1972acc1ecda9$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $ceb1972acc1ecda9$var$mutateDom(()=>$ceb1972acc1ecda9$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $ceb1972acc1ecda9$var$getInputValue(el, modifiers, event, currentValue) {
    return $ceb1972acc1ecda9$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($ceb1972acc1ecda9$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $ceb1972acc1ecda9$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $ceb1972acc1ecda9$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$ceb1972acc1ecda9$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $ceb1972acc1ecda9$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $ceb1972acc1ecda9$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($ceb1972acc1ecda9$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $ceb1972acc1ecda9$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $ceb1972acc1ecda9$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $ceb1972acc1ecda9$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $ceb1972acc1ecda9$var$isNumeric2(number) ? number : rawValue;
}
function $ceb1972acc1ecda9$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $ceb1972acc1ecda9$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $ceb1972acc1ecda9$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$ceb1972acc1ecda9$var$directive("cloak", (el)=>queueMicrotask(()=>$ceb1972acc1ecda9$var$mutateDom(()=>el.removeAttribute($ceb1972acc1ecda9$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$ceb1972acc1ecda9$var$addInitSelector(()=>`[${$ceb1972acc1ecda9$var$prefix("init")}]`);
$ceb1972acc1ecda9$var$directive("init", $ceb1972acc1ecda9$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$ceb1972acc1ecda9$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$ceb1972acc1ecda9$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $ceb1972acc1ecda9$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$ceb1972acc1ecda9$var$mapAttributes($ceb1972acc1ecda9$var$startingWith(":", $ceb1972acc1ecda9$var$into($ceb1972acc1ecda9$var$prefix("bind:"))));
var $ceb1972acc1ecda9$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $ceb1972acc1ecda9$var$injectBindingProviders(bindingProviders);
        let getBindings = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $ceb1972acc1ecda9$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $ceb1972acc1ecda9$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $ceb1972acc1ecda9$var$mutateDom(()=>$ceb1972acc1ecda9$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$ceb1972acc1ecda9$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$ceb1972acc1ecda9$var$directive("bind", $ceb1972acc1ecda9$var$handler2);
function $ceb1972acc1ecda9$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$ceb1972acc1ecda9$var$addRootSelector(()=>`[${$ceb1972acc1ecda9$var$prefix("data")}]`);
$ceb1972acc1ecda9$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($ceb1972acc1ecda9$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $ceb1972acc1ecda9$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $ceb1972acc1ecda9$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $ceb1972acc1ecda9$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $ceb1972acc1ecda9$var$injectMagics(data2, el);
    let reactiveData = $ceb1972acc1ecda9$var$reactive(data2);
    $ceb1972acc1ecda9$var$initInterceptors(reactiveData);
    let undo = $ceb1972acc1ecda9$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $ceb1972acc1ecda9$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $ceb1972acc1ecda9$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$ceb1972acc1ecda9$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $ceb1972acc1ecda9$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$ceb1972acc1ecda9$var$isCloning) return false;
    if ($ceb1972acc1ecda9$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$ceb1972acc1ecda9$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $ceb1972acc1ecda9$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$ceb1972acc1ecda9$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $ceb1972acc1ecda9$var$parseForExpression(expression);
    let evaluateItems = $ceb1972acc1ecda9$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $ceb1972acc1ecda9$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$ceb1972acc1ecda9$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$ceb1972acc1ecda9$var$mutateDom(()=>{
                $ceb1972acc1ecda9$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $ceb1972acc1ecda9$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($ceb1972acc1ecda9$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $ceb1972acc1ecda9$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $ceb1972acc1ecda9$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                $ceb1972acc1ecda9$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                if (!elForSpot) $ceb1972acc1ecda9$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $ceb1972acc1ecda9$var$reactive(scope2);
            $ceb1972acc1ecda9$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                lastEl.after(clone2);
                $ceb1972acc1ecda9$var$skipDuringClone(()=>$ceb1972acc1ecda9$var$initTree(clone2))();
            });
            if (typeof key === "object") $ceb1972acc1ecda9$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $ceb1972acc1ecda9$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $ceb1972acc1ecda9$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $ceb1972acc1ecda9$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $ceb1972acc1ecda9$var$handler3() {}
$ceb1972acc1ecda9$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $ceb1972acc1ecda9$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$ceb1972acc1ecda9$var$directive("ref", $ceb1972acc1ecda9$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$ceb1972acc1ecda9$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $ceb1972acc1ecda9$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $ceb1972acc1ecda9$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $ceb1972acc1ecda9$var$addScopeToNode(clone2, {}, el);
        $ceb1972acc1ecda9$var$mutateDom(()=>{
            el.after(clone2);
            $ceb1972acc1ecda9$var$skipDuringClone(()=>$ceb1972acc1ecda9$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $ceb1972acc1ecda9$var$mutateDom(()=>{
                $ceb1972acc1ecda9$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$ceb1972acc1ecda9$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$ceb1972acc1ecda9$var$setIdRoot(el, name));
});
$ceb1972acc1ecda9$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$ceb1972acc1ecda9$var$mapAttributes($ceb1972acc1ecda9$var$startingWith("@", $ceb1972acc1ecda9$var$into($ceb1972acc1ecda9$var$prefix("on:"))));
$ceb1972acc1ecda9$var$directive("on", $ceb1972acc1ecda9$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $ceb1972acc1ecda9$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $ceb1972acc1ecda9$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Focus", "trap", "focus");
$ceb1972acc1ecda9$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $ceb1972acc1ecda9$var$warnMissingPluginDirective(name, directiveName, slug) {
    $ceb1972acc1ecda9$var$directive(directiveName, (el)=>$ceb1972acc1ecda9$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$ceb1972acc1ecda9$var$alpine_default.setEvaluator($ceb1972acc1ecda9$var$normalEvaluator);
$ceb1972acc1ecda9$var$alpine_default.setReactivityEngine({
    reactive: $ceb1972acc1ecda9$var$reactive2,
    effect: $ceb1972acc1ecda9$var$effect2,
    release: $ceb1972acc1ecda9$var$stop,
    raw: $ceb1972acc1ecda9$var$toRaw
});
var $ceb1972acc1ecda9$export$b7ee041e4ad2afec = $ceb1972acc1ecda9$var$alpine_default;
// packages/alpinejs/builds/module.js
var $ceb1972acc1ecda9$export$2e2bcd8739ae039 = $ceb1972acc1ecda9$export$b7ee041e4ad2afec;

});


//# sourceMappingURL=repo.2dc2aed2.js.map
